/* Listicle advertorials: analytics, sticky bar, PDP links and short-listicle checkout. */
(() => {
  const root = document.querySelector("[data-listicle]");
  if (!root) return;
  const variant = root.dataset.funnelVariant;
  const quiz = () => window.MosesQuiz;
  const track = (name, data = {}) => {
    try { quiz()?.track(name, { funnel_variant: variant, ...data }); } catch { /* non-blocking */ }
  };

  // Tag the session so quiz, cart and checkout events carry this variant.
  try { quiz()?.save({ funnelVariant: variant }); } catch { /* storage blocked */ }
  track("ad_page_view");

  root.querySelectorAll("[data-lx-cta]").forEach((link) => {
    if (link.hasAttribute("data-lx-pdp")) {
      const destination = new URL(link.href, location.origin);
      for (const [key, value] of new URLSearchParams(location.search)) {
        if (key.startsWith("utm_") || ["fbclid", "gclid", "preview_theme_id", "pb"].includes(key)) {
          destination.searchParams.set(key, value);
        }
      }
      link.href = destination.href;
    }
    link.addEventListener("click", (event) => {
      track("ad_cta_click", { placement: link.dataset.lxCta });
      if (!link.hasAttribute("data-lx-pdp") || event.defaultPrevented || event.button !== 0 ||
          event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
          link.target === "_blank" || link.hasAttribute("download")) return;
      event.preventDefault();
      setTimeout(() => location.assign(link.href), 250);
    });
  });

  const offer = root.querySelector("[data-lx-offer]");
  const offerSection = root.querySelector("#offer");
  const sticky = root.querySelector("[data-lx-sticky]");
  const hero = root.querySelector(".lx-hero");

  // Sticky bar: after the hero, hidden while the offer is on screen.
  if (sticky && hero && offerSection && "IntersectionObserver" in window) {
    let pastHero = false;
    let offerVisible = false;
    const link = sticky.querySelector("a");
    const sync = () => {
      const show = pastHero && !offerVisible;
      sticky.classList.toggle("is-visible", show);
      sticky.setAttribute("aria-hidden", String(!show));
      if (link) link.tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; sync(); }).observe(hero);
    new IntersectionObserver(([e]) => { offerVisible = e.isIntersecting; sync(); }, { threshold: 0.1 }).observe(offerSection);
  }
  if (!offer) return;

  const button = offer.querySelector("[data-lx-buy]");
  const label = offer.querySelector("[data-lx-buy-label]");
  const errorEl = offer.querySelector("[data-lx-error]");
  const selected = () => offer.querySelector('input[name="lxo-plan"]:checked');

  const syncPlan = () => {
    const input = selected();
    if (!input) return;
    if (label && !button.disabled) label.textContent = input.dataset.label;
    const stickyPrice = sticky?.querySelector("[data-lx-sticky-price]");
    if (stickyPrice) stickyPrice.textContent = input.dataset.stickyPrice + " · " + input.dataset.stickySub;
  };
  offer.addEventListener("change", (event) => {
    if (event.target.name !== "lxo-plan") return;
    syncPlan();
    track("ad_cta_click", { placement: "plan-" + event.target.value });
  });
  syncPlan();

  const json = async (url, body) => {
    const response = await fetch(url, {
      method: body ? "POST" : "GET",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) throw new Error("We couldn’t add your retainer. Please try again.");
    return response.json();
  };

  button.addEventListener("click", async () => {
    if (button.disabled) return;
    errorEl.hidden = true;
    if (!quiz()?.storageAvailable()) {
      errorEl.textContent = "Please allow session storage to complete the fit check before checkout.";
      errorEl.hidden = false;
      return;
    }
    const api = quiz();
    if (!api) {
      errorEl.textContent = "We couldn’t open the fit check. Refresh the page and try again.";
      errorEl.hidden = false;
      return;
    }
    const input = selected();
    const plan = input?.value || "once";
    const sellingPlan = input?.dataset.sellingPlan;
    const code = offer.dataset.discountCode;
    track("ad_cta_click", { placement: "offer-" + plan });
    button.disabled = true;
    for (const radio of offer.querySelectorAll('input[name="lxo-plan"]')) radio.disabled = true;
    try {
      // One retainer per order: drop any retainer already in the cart, then add the chosen plan.
      let cart = await json("/cart.js");
      const gifts = (offer.dataset.complimentary || "").split(",").map(Number).filter(Boolean);
      const updates = {};
      for (const item of cart.items) {
        if (api.isRetainer(item) || item.properties?._moses_listicle_gift === "true" ||
            (!sellingPlan && gifts.includes(item.variant_id) && item.final_line_price === 0)) updates[item.key] = 0;
      }
      if (Object.keys(updates).length) cart = await json("/cart/update.js", { updates });
      const line = { id: Number(offer.dataset.variantId), quantity: 1 };
      if (sellingPlan) line.selling_plan = Number(sellingPlan);
      const items = [line];
      if (sellingPlan) {
        // Free welcome case on plan orders, same as the PDP (an automatic discount zeroes it).
        const inCart = new Set(cart.items.map((item) => item.variant_id));
        for (const id of gifts) if (!inCart.has(id)) items.push({ id, quantity: 1, properties: { _moses_listicle_gift: "true" } });
      }
      await json("/cart/add.js", { items });
      if (plan === "plan" && code) {
        // Sets the discount cookie; Shopify applies it at checkout.
        await fetch("/discount/" + encodeURIComponent(code) + "?redirect=%2Fcart.js").catch(() => {});
      }
      api.save({ funnelVariant: variant });
      await new Promise(resolve => setTimeout(resolve, 250));
      api.start({ checkout: true, emailGate: false, returnUrl: location.pathname + location.search + "#offer" });
    } catch (error) {
      errorEl.textContent = error.message;
      errorEl.hidden = false;
      button.disabled = false;
      for (const radio of offer.querySelectorAll('input[name="lxo-plan"]')) radio.disabled = false;
      syncPlan();
    }
  });
})();
